import { Config } from '@measured/puck';

import { CardBlock } from '../../shared/blocks/card/card';
import { ColumnBlock } from '../../shared/blocks/column/column';
import { FlexBlock } from '../../shared/blocks/flex/flex';
import { GridBlock } from '../../shared/blocks/grid/grid';
import { MarkdownBlock } from '../../shared/blocks/markdown/markdown';
import { SpacerBlock } from '../../shared/blocks/spacer/spacer';
import { LandingPageMetadata } from '../types';

import { createRootConfig } from './create-root-config';
import {
  createProxiedAccordianBlock,
  createProxiedHeaderBlock,
  createProxiedListBlock,
  createProxiedTextBlock,
} from './proxied-blocks';

const categories = {
  layout: {
    components: ['ColumnBlock', 'FlexBlock', 'GridBlock', 'CardBlock', 'SpacerBlock'],
  },
  typography: {
    components: ['AccordianBlock', 'TextBlock', 'ListBlock', 'HeaderBlock', 'MarkdownBlock'],
  },
};

const createConfig = ({ metadata }: { metadata: LandingPageMetadata }): Config => {
  return {
    root: createRootConfig(),
    categories: categories,
    components: {
      AccordianBlock: createProxiedAccordianBlock(metadata),
      CardBlock,
      ColumnBlock,
      FlexBlock,
      GridBlock,
      HeaderBlock: createProxiedHeaderBlock(metadata),
      ListBlock: createProxiedListBlock(metadata),
      MarkdownBlock,
      SpacerBlock,
      TextBlock: createProxiedTextBlock(metadata),
    },
  };
};

export { createConfig };
